
export { default as always } from "./always.js"
export { default as anyPass } from "./anyPass.js"
export { default as applySpec } from "./applySpec.js"
export { default as assoc } from "./assoc.js"
export { default as complement } from "./complement.js"
export { default as converge } from "./converge.js"
export { default as curry } from "./curry.js"
export { default as equals } from "./equals.js"
export { default as head } from "./head.js"
export { default as identity } from "./identity.js"
export { default as ifElse } from "./ifElse.js"
export { default as is } from "./is.js"
export { default as isEmpty } from "./isEmpty.js"
export { default as isNil } from "./isNil.js"
export { default as keys } from "./keys.js"
export { default as map } from "./map.js"
export { default as mergeRight } from "./mergeRight.js"
export { default as pipe } from "./pipe.js"
export { default as reduce } from "./reduce.js"
export { default as split } from "./split.js"
export { default as toPairs } from "./toPairs.js"